import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { supabase } from "@/lib/supabase";

export default function RecruitmentShell({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const bootstrap = async () => {
      const {
        data: { user: currentUser },
      } = await supabase.auth.getUser();
      setUser(currentUser ?? null);
    };

    bootstrap();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="relative min-h-screen text-slate-900">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(183, 190, 221, 0.8) 0%, rgba(49, 48, 49, 0.8) 100%), url(/media/background.png)",
          backgroundAttachment: "fixed",
        }}
      />

      <div className="relative z-10 min-h-screen">
        <header className="border-b border-white/40 bg-white/35 backdrop-blur-md">
          <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-4">
            <Link to="/" className="rounded-md px-1 py-1 transition-colors hover:bg-white/35">
              <p
                className="text-sm font-bold uppercase tracking-wide text-blue-700"
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                KConnect
              </p>
              <h1 className="text-lg font-bold">Rekrutacja</h1>
            </Link>
            <div className="flex items-center gap-3 rounded-md border border-white/45 bg-white/35 px-3 py-2 backdrop-blur-md">
              <p className="text-sm text-slate-800">
                Zalogowany: <span className="font-semibold">{user?.email || "Gość"}</span>
              </p>
              {user ? (
                <Button type="button" size="sm" variant="outline" onClick={signOut}>
                  Wyloguj
                </Button>
              ) : null}
            </div>
          </div>
        </header>
        <main className="mx-auto w-full max-w-6xl px-4 py-8">{children}</main>
      </div>
    </div>
  );
}
